import { Component, ViewEncapsulation, inject } from '@angular/core';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';

@Component({
  selector: 'app-exportaciones',
  templateUrl: './exportaciones.component.html',
  styleUrl: './exportaciones.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class ExportacionesComponent {  helper = inject(HelperService);

}
